module.exports = __webpack_public_path__ + "static/img/denglv-img.13bac9a9.png";